import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import PageHeader from "../../Components/Pageheader";
import Siderbar from "./Siderbar";
import ReUse from "../../services/helpers/reUse";
import { toast } from "react-toastify";
import AppService from "../../services/appServices";
import { useDispatch } from "react-redux";
import AccessControl from "../../Components/Auth/AccessControl";
import UserAddresses from "./UserAddresses";
import MyAddresses from "./MyAddresses";
import AddressAddModal from "./AddressAddModal";
import {
  ResponseMessageActions,
  clearResponseMessageAfterDelay,
  errorMessage,
  successMessage,
} from "../../redux/slices/responseMessage.slice";
import ResponseMessage from "../../Components/ReUse/ResponseMessage";
import CustomButton from "../../Components/ReUse/Components/Button";
import FieldError from "../../Components/ReUse/FieldError";
import ProfileDetailContent from "../../Components/PID/ProfileDetailContent";
import { upperarrow } from "../../Constant/Index";
import RenderImage from "../../Components/ReUse/RenderImage";

function Editprofile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [fileupload, setFileupload] = useState();
  const [newfileall, setNewFileall] = useState();
  const [fileuploadall, setFileuploadall] = useState();
  const [uploadLoading, setUploadLoading] = useState();

  const [allErrors, setAllErrors] = useState({
    first_name: "",
    last_name: "",
    // email: "",
    phone: "",
    dob: "",
    image: "",
  });

  const [fieldsData, setFieldsData] = useState({
    first_name: "",
    last_name: "",
    // email: "",
    phone: "",
    dob: "",
    image: "",
  });

  function handleChange(e) {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    const { value, name } = e.target;
    setFieldsData({
      ...fieldsData,
      [name]: value,
    });
  }

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { first_name, last_name, phone, dob, image, email } = fieldsData;

      const fields = {
        first_name,
        last_name,
        phone,
        dob,
        // email,
      };
      const allErrors = ReUse.validateRequired({ fields: fields });

      // Check if there are any errors
      if (Object.keys(allErrors).length > 0) {
        setAllErrors(allErrors);
        setLoading(false);
        return;
      }

      const payLoad = {
        first_name,
        last_name,
        phone,
        dob,
        image: newfileall,
        // email,
      };

      const apiResp = await AppService.customerUpdateProfile(payLoad);
      const { message, response } = apiResp.data;
      setLoading(false);
      dispatch(successMessage(message));
      setTimeout(() => {
        dispatch(successMessage("Navigating..."));
        setTimeout(() => {
          dispatch(successMessage(""));
          navigate("/my-profile");
        }, 1000);
      }, 1000);

      ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
      ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
    } catch (err) {
      setLoading(false);
      dispatch(errorMessage(err?.response?.data?.message));
      dispatch(clearResponseMessageAfterDelay());
      ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
      ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
      dispatch(successMessage(""));
    }
  };

  //   const handleProfileUpload = (e) => {
  //     const resetErrors = ReUse.resetErrors({ fields: allErrors });
  //     setAllErrors(resetErrors);
  //     ReUse.handleFileUploads(e).then((result) => {
  //       const { fileOutput, fileUpload } = result;
  //       setFile(fileOutput);
  //       setFileupload(fileUpload);
  //     });
  //   };

  const handleImageUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setNewFileall(file);
      setFileuploadall(reader.result);
      //   setFileupload(file);
      //   console.log(file, "newFile")
    };
    reader.readAsDataURL(file);
    setUploadLoading(true);
  };

  const { first_name, last_name,phone, dob } = fieldsData ?? {};

  return (
    <>
      <Header />
      <PageHeader pagename="Edit My Profile" />
      {/* Edit Profle Seciton */}
      <AccessControl allowedRoles={["customer"]}>
        <section className="edit-profile-sec my-profile-all">
          <div className="container">
            <div className="row">
              <div className="col-md-2">
                {/* <Siderbar handleProfileUpload={handleProfileUpload} /> */}
                <Siderbar />
              </div>
              <div className="col-md-10">
                <div className="all-edit-screen">
                  <div className="row">
                    <div className="col-md-10">
                      <form>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="edit-profile-input">
                              <input
                                type="text"
                                placeholder="first name"
                                onChange={handleChange}
                                name="first_name"
                                value={first_name}
                              />
                              <FieldError fieldName={allErrors?.first_name} />
                              <div className="icon-of-edit-profile">
                                <i class="fa fa-user" aria-hidden="true"></i>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="edit-profile-input">
                              <input
                                type="text"
                                placeholder="last name"
                                onChange={handleChange}
                                name="last_name"
                                defaultValue={last_name}
                              />
                              <FieldError fieldName={allErrors?.last_name} />
                              <div className="icon-of-edit-profile">
                                <i class="fa fa-user" aria-hidden="true"></i>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-6">
														<div className="edit-profile-input">
															<input
																type="email"
																placeholder="Email "
																onChange={handleChange}
																name="email"
																defaultValue={email}
															/>
															<FieldError fieldName={allErrors?.email} />
															<div className="icon-of-edit-profile">
																<i
																	class="fa fa-envelope"
																	aria-hidden="true"
																></i>
															</div>
														</div>
													</div> */}
                          <div className="col-md-6">
                            <div className="edit-profile-input">
                              <input
                                type="text"
                                placeholder="phone"
                                onChange={handleChange}
                                name="phone"
                                defaultValue={phone}
                              />
                              <FieldError fieldName={allErrors?.phone} />
                              <div className="icon-of-edit-profile">
                                <i class="fa fa-phone" aria-hidden="true"></i>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="edit-profile-input">
                              <input
                                type="text"
                                placeholder="DOB"
                                onChange={handleChange}
                                name="dob"
                                defaultValue={dob}
                              />
                              <FieldError fieldName={allErrors?.dob} />
                              <div className="icon-of-edit-profile">
                                <i
                                  class="fa fa-calendar-minus-o"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="label-img-shadow">
                              <div className="all-img-with-shadow all-img-shadow-profile">
                                <figure>
                                  {/* <img className="img-fluid" src={sketch} /> */}
                                  <RenderImage file={fileuploadall} />
                                </figure>
                              </div>
                            </div>
                            <div className="upload-btn profile-upload-btn">
                              <button>
								Upload
                             
                                <input
                                  type="file"
                                  accept="*"
                                  multiple={false}
                                  // onChange={handleThumbnailUpload}
                                  onChange={handleImageUpload}
                                />
                               
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="col-md-2">
                      <div className="profile-edit-btn">
                        <a>
                          <CustomButton
                            loading={loading}
                            onClickHandler={onSubmitHandler}
                            customClassName="btn"
                          >
                            Submit
                          </CustomButton>
                        </a>
                        <ResponseMessage />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </AccessControl>

      {/* ============================ */}
      <Footer />
    </>
  );
}

export default Editprofile;
